import * as classNames from "classnames";
import { memo } from "react";
import ColorsIcon from "../../arbiter-icon/colors.svg";
import { Flex } from "../../flex";
import AlignCenterIcon from "../../icon-old/align-center.svg";
import AlignLeftIcon from "../../icon-old/align-left.svg";
import AlignRightIcon from "../../icon-old/align-right.svg";
import BoldIcon from "../../icon-old/bold.svg";
import FontSizeIcon from "../../icon-old/font-size.svg";
import ItalicIcon from "../../icon-old/italic.svg";
import LinkIcon from "../../icon-old/link2.svg";
import ListIcon from "../../icon-old/list.svg";
import StrikethroughIcon from "../../icon-old/strikethrough.svg";
import UnderlineIcon from "../../icon-old/underline.svg";
import * as richTextEditorCss from "./forge-quill-editor.module.css";

export interface FontSize {
  label: string;
  value: string;
}

export const FormQuillEditorToolbar = memo(function FormQuillEditorToolbar({
  open,
  id = "toolbar",
}: {
  open: boolean;
  id?: string;
}) {
  const fontSizes = [
    { label: "Small", value: "small" },
    { label: "Medium", value: "" }, // Quill expects blank for default size
    { label: "Large", value: "large" },
    { label: "Huge", value: "huge" },
  ];
  return (
    <Flex
      className={richTextEditorCss.textFormattingToolbar}
      gap="none"
      id={id}
      onMouseDown={(e) => e.stopPropagation()}
      style={{ display: open ? "flex" : "none" }}
    >
      {/* inline style works with Quill's magic much better than external CSS */}
      {/* The id="toolbar" is required for Quill to detect this toolbar */}
      <div className={richTextEditorCss.dropDownWrapper} id="toolbar">
        <select
          className={classNames(
            "ql-size",
            richTextEditorCss.dropDownSelector,
            richTextEditorCss.textToolbarOption,
          )}
          defaultValue=""
          style={{ height: "100%" }}
        >
          {fontSizes.map((size) => (
            <option
              className={`ql-${size.value}`}
              key={size.value}
              value={size.value}
            >
              {size.label}
            </option>
          ))}
        </select>
        <FontSizeIcon />
      </div>
      <div className={richTextEditorCss.textToolbarOption}>
        <BoldIcon />
        <button className="ql-bold" />
      </div>
      <div className={richTextEditorCss.textToolbarOption}>
        <ItalicIcon />
        <button className="ql-italic" />
      </div>
      <div className={richTextEditorCss.textToolbarOption}>
        <UnderlineIcon />
        <button className="ql-underline" />
      </div>
      <div className={richTextEditorCss.textToolbarOption}>
        <StrikethroughIcon />
        <button className="ql-strike" />
      </div>
      <div className={richTextEditorCss.textToolbarOption}>
        <AlignLeftIcon />
        <button className="ql-align" value="right" />
      </div>
      <div className={richTextEditorCss.textToolbarOption}>
        <AlignCenterIcon />
        <button className="ql-align" value="center" />
      </div>
      <div className={richTextEditorCss.textToolbarOption}>
        <AlignRightIcon />
        <button className="ql-align" value="right" />
      </div>
      <div className={richTextEditorCss.textToolbarOption}>
        <ListIcon />
        <button className="ql-list" value="bullet" />
      </div>
      <div className={richTextEditorCss.textToolbarOption}>
        <LinkIcon />
        <button className="ql-link" />
      </div>
      <div className={richTextEditorCss.dropDownWrapper}>
        <select
          className={classNames(
            "ql-color",
            richTextEditorCss.dropDownSelector,
            richTextEditorCss.textToolbarOption,
          )}
          defaultValue=""
          style={{ height: "100%" }}
        />
        <ColorsIcon />
      </div>
    </Flex>
  );
});
